import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=c16f5868"
import script from "./BulletinBoard.vue?vue&type=script&lang=js"
export * from "./BulletinBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports